module.exports = __webpack_public_path__ + "static/media/i1a.cbc73e31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i1a.svg
// module id = 554
// module chunks = 12